import React from 'react';
import {missingAirlineCode} from "./MissingAirlineCode";
import {ApiCall} from "./axios";
import { getActiveRate, getCurrencyMeta, getCurrencyOverride } from "./currencyState";
import { fromUrlSource } from "./vendorMask";

const airlineImageLink = `${process.env.s3ImageUrl}/airline-img`;
const countryFlagLink = `${process.env.s3ImageUrl}/country-flag-img`;
export const agentDefaultImage = 'https://secure.gravatar.com/avatar/5d5da19d0b586dbb613d36bcba6be2ac?s=96&d=mm&r=g';
export const defaultAirlineCompanyListArr = [/*'tripjack', 'amadeus', 'akasa-air', 'air-arabia',*/ 'travel-fusion']

const airlineImageFn = (code) => {
    if(missingAirlineCode.includes(code)){
        return `${airlineImageLink}/dummy.png`
    }else{
        return `${airlineImageLink}/${code}.png`
    }
}

const phoneCodeImageFn = (code) => {
    return `${countryFlagLink}/${code}-flag.jpg`
}

const getQueryParams = (search) => {
    const queryParams = new URLSearchParams(search);
    const params = {
        adult: queryParams.get('ADT'),
        child: queryParams.get('CHD'),
        infant: queryParams.get('INF'),
        passageClass: queryParams.get('pClass'),
        directFlight: queryParams.get('directFlight'),
        airlineCode: queryParams.get('airlineCode'),
        type: queryParams.get('type'),
        nearByAirport : queryParams.get('nearByAirport'),
    };

    if (params.type === 'combo') {
        params.segments = [];
        let index = 0;
        while (queryParams.get(`from[${index}]`)) {
            params.segments.push({
                fromAirport: queryParams.get(`from[${index}]`),
                toAirport: queryParams.get(`to[${index}]`),
                departDate: queryParams.get(`dep[${index}]`)
            });
            index++;
        }
    } else {
        params.fromAirport = queryParams.get('from');
        params.toAirport = queryParams.get('to');
        params.departDate = queryParams.get('dep');
        params.returnDate = queryParams.get('ret');
    }

    return params;
}

const getUserTokenFn = (search) => {
    const queryParams = new URLSearchParams(search);
    return queryParams.get('token');
}

const getUserId = (search) => {
    return 123;
}



const getWithoutUserLogin = () => {
    return window?.location?.search?.includes('excloginAdmin');
}

const countryCommonFn = (countryCode) => {
    let countryISOCode = countryCode;
    if (countryISOCode === 'uk') {
        countryISOCode = 'gb';
    } else if (countryISOCode === 'uae') {
        countryISOCode = 'ae';
    }

    countryISOCode = countryISOCode?.toUpperCase() || ''
    return countryISOCode;
}

const getUserToken = () => {
    return getCookie('dahrToursUserToken')
}

const setUserToken = (token) => {
    setCookie('dahrToursUserToken',token, 24);
}

const getBookingQueryParams = (search) => {
    const queryParams = new URLSearchParams(search);
    return {
        priceId: queryParams.get('priceId'),
        outwardId: queryParams.get('outwardId'),
        returnId: queryParams.get('returnId'),
        source: fromUrlSource(queryParams.get('source')),
        bookingId : queryParams.get('bookingId'),
        bookingReferenceNumber : queryParams.get('bookingReferenceNumber'),
        token : queryParams.get('amaduestoken'),
        sid : queryParams.get('sid'),
        type : queryParams.get('type'),
        status : queryParams.get('status'),
        detail : queryParams.get('detail'),
        refreshPage : queryParams.get('refresh'),
        freshBooking : queryParams.get('freshBooking'),
        jKey : queryParams.get('jKey'),
        searchData : queryParams.get('searchData'),
        pass : queryParams.get('pass'),
        bundleCode : queryParams.get('bundle'),
        flightId : queryParams.get("flightId")
    };
}

function formatDateTime(dateTimeString) {
    const date = new Date(dateTimeString);
    const time = date.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit', hour12: false});
    const options = {month: 'short', day: '2-digit'};
    const dateWithDayOption =  {  month: 'short', day: '2-digit',weekday: 'short' };
    const formattedDate = date.toLocaleDateString('en-US', options);
    const dayWithDay = date.toLocaleDateString('en-US', dateWithDayOption);
    const dayWithDayFormatted = dayWithDay.split(', ').reverse().join(', ');
    return {
        time: time,
        date: formattedDate,
        dateWithDay : dayWithDayFormatted
    };
}

function formatDateMonthWise(isoString) {
    const date = new Date(isoString);
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
}


function getDateDifference(date1, date2) {
    const d1 = new Date(date1);
    const d2 = new Date(date2);
    d1.setHours(0, 0, 0, 0);
    d2.setHours(0, 0, 0, 0);
    const timeDiff = d2 - d1;
    const daysDiff = timeDiff / (1000 * 3600 * 24);
    return Math.abs(Math.floor(daysDiff));
}

const convertMinutesFn = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    return `${hours}h ${remainingMinutes} min`;
}

const convertMinutesHeaderFn = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    return `${hours}h ${remainingMinutes}m`;
}

const convertHourseFn = (minutes) => {
    const hours = Math.floor(minutes / 60);
    return `${hours}h`;
}

const formatDayWiseDateFn = (dateString) => {
    const date = new Date(dateString);
    const suffixes = ["th", "st", "nd", "rd"];
    const day = date.getDate();

    // Correct suffix logic
    const daySuffix = (day % 100 >= 11 && day % 100 <= 13)
        ? "th"
        : suffixes[day % 10] || "th";

    const options = {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    };

    const formattedDate = date.toLocaleDateString('en-US', options);

    // Replace day number with day + suffix
    return formattedDate.replace(/\b\d+\b/, day + daySuffix);
};


const formatTimeWithDayAndTimeFn = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = date.toLocaleString('en-US', {month: 'short'});
    const weekday = date.toLocaleString('en-US', {weekday: 'short'});
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${month} ${day}, ${weekday}, ${hours}:${minutes}`;
}

const differenceBetweenTwoDatesWithTime = (startDate, endDate) => {
    let startTime = new Date(startDate);
    let endTime = new Date(endDate);
    let difference = endTime - startTime;
    let hours = Math.abs(Math.floor(difference / (1000 * 60 * 60)));
    let minutes = Math.abs(Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)));
    return `${hours}h ${minutes}m`;
}

const getMinutesDifference = (date1) =>  {
    const diffMs = Math.abs(new Date() - new Date(date1));
    return Math.floor(diffMs / (1000 * 60));
}

const passengerFormatString = (str) => {
    let string = str;
    if(string === 'ADT'){
        string = 'ADULT'
    }else if(string === 'CHD'){
        string = 'CHILD'
    }else if(string === 'INF'){
        string = 'INFANT'
    }

    return string
        .toLowerCase()
        .replace(/_/g, ' ')
        .replace(/(?:^|\s)\S/g, (match) => match.toUpperCase());
}

const addServiceFees = (amount,serviceFees,roundOff = false,decimalRemove=false) => {
    const formatter = new Intl.NumberFormat('en-IN', {
        minimumFractionDigits: decimalRemove ? 0 : 2,
        maximumFractionDigits: decimalRemove ? 0 : 2
    });
    if(amount && serviceFees){
        let value = (parseFloat(amount) * parseFloat(serviceFees) / 100)
        value = formatter.format(amount + value);
        return roundOff ? Math.round(value).toFixed(2) : value
    }
    return formatter.format(amount)
}

function formatPrice(number,roundOff=false,decimalRemove = false,isExcursion=false) {
    // DISPLAY conversion: amounts are stored/charged in AED; here we convert to
    // the active display currency at its rate. Backend/charge amounts never use this.
    number = Number(number || 0) * getActiveRate();
    if(isExcursion){
        const rounded = Math.round(number * 100) / 100
        let str = rounded.toFixed(2)
        if (str.endsWith('.00')) {
            str = str.slice(0, -3)
        }
        const parts = str.split('.');
        parts[0] = Number(parts[0]).toLocaleString('en-US');
        return parts.length === 2 ? parts[0] + '.' + parts[1] : parts[0];
    }
    const value = roundOff ? number : number;

    // Create a custom formatter for the Indian number system
    const formatter = new Intl.NumberFormat('en-IN', {
        minimumFractionDigits: decimalRemove ? 2 : 2,
        maximumFractionDigits: decimalRemove ? 2 : 2
    });
    let formattedValue = formatter.format(parseFloat(value))
    return formattedValue
}

// Same as formatPrice but converts using an EXPLICIT rate (e.g. a booking's
// stored AED->currency rate) instead of the live active rate. Used on booking
// detail pages so the amount always reflects the currency the booking was made
// in, unaffected by the current currency switcher.
function formatPriceWithRate(number, rate = 1, isExcursion = false) {
    number = Number(number || 0) * Number(rate || 1);
    if (isExcursion) {
        const rounded = number
        let str = rounded.toFixed(2)
        if (str.endsWith('.00')) {
            str = str.slice(0, -3)
        }
        const parts = str.split('.');
        parts[0] = Number(parts[0]).toLocaleString('en-IN');
        return parts.length === 2 ? parts[0] + '.' + parts[1] : parts[0];
    }
    const formatter = new Intl.NumberFormat('en-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
    return formatter.format(parseFloat(number))
}

function setCookie(name, value, expirationHours, domain) {
    var expirationDate = new Date();
    expirationDate.setTime(expirationDate.getTime() + (expirationHours * 60 * 60 * 1000));
    var expires = "expires=" + (expirationHours ? expirationDate.toUTCString() : 0);
    var domainPart = domain ? ";domain=" + domain : "";
    document.cookie = name + "=" + value + ";" + expires + ";path=/" + domainPart;
}

// Returns the shared parent-domain (e.g. ".dahrb2b.com") so a single cookie can
// be shared between the WordPress site and the React app when they run on
// sibling subdomains. Returns null on localhost / IP (host-scoped cookie).
function getSharedCookieDomain() {
    try {
        var host = (".dahrb2b.com").toLowerCase();
        if (!host || host === "localhost" || /^\d{1,3}(\.\d{1,3}){3}$/.test(host)) return null;
        var parts = host.split(".");
        if (parts.length < 2) return null;
        return "." + parts.slice(-2).join(".");
    } catch (_) { return null; }
}

// Deletes a host-scoped cookie (no domain attribute). Used to drop a legacy
// host-only copy so the shared parent-domain cookie is the single source of truth.
function eraseHostCookie(name) {
    document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
}

function setSessionStorage(name, value) {
    sessionStorage.setItem(name, value);
}
function getSessionStorage(name) {
    const item = sessionStorage.getItem(name);
    try {
        return JSON.parse(item);
    } catch (e) {
        return item; // Return raw if not JSON
    }
}



// Function to get the value of a cookie by name
function getCookie(name) {
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i].trim();
        if (cookie.indexOf(name + "=") == 0) {
            return cookie.substring(name.length + 1, cookie.length);
        }
    }
    return null;
}

function convertToMinutesAndSeconds(seconds) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    const formattedMinutes = minutes.toString().padStart(2, '0');
    const formattedSeconds = remainingSeconds.toString().padStart(2, '0');
    return `${formattedMinutes} mins : ${formattedSeconds} secs`;
}

function calcNights(startDate, endDate) {
    const start = new Date(startDate);
    const end = new Date(endDate);
    if (isNaN(start.getTime()) || isNaN(end.getTime())) {
        return 0
    }
    const millisecondsPerDay = 1000 * 60 * 60 * 24;
    const differenceInMs = end - start;
    const nights = differenceInMs / millisecondsPerDay;
    return Math.max(0, nights);
}

const getYearOnDob = (date) => {
    if (!date || isNaN(new Date(date).getTime())) {
        return '';
    }
    let birthDate = new Date(date);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
}

const normalizeSeatsMap = (apiData) => {
    let cabinClass = apiData?.["soap:Envelope"]?.["soap:Body"]?.["ns1:OTA_AirSeatMapRS"]?.["ns1:SeatMapResponses"]?.["ns1:SeatMapResponse"]?.["ns1:SeatMapDetails"]?.["ns1:CabinClass"];
    if(!Array.isArray(cabinClass)){
        cabinClass = cabinClass ? [cabinClass] : []
    }
    let allRows = []
    cabinClass?.forEach(cabin => {
        let airRows = cabin?.["ns1:AirRows"]?.["ns1:AirRow"]
        if (airRows) {
            if (!Array.isArray(airRows)) airRows = [airRows]
            allRows = allRows.concat(
                airRows.map(row => {
                    let seats = Array.isArray(row?.["ns1:AirSeats"]?.["ns1:AirSeat"]) ?
                        row["ns1:AirSeats"]["ns1:AirSeat"].map(seat => ({ ...seat["$"] })) :
                        [];
                    if (seats.length >= 6) {
                        seats = [
                            ...seats.slice(0, 3),
                            { isGap: true },
                            ...seats.slice(3)
                        ];
                    }
                    const isExit = row?.["$"]?.RowNumber === "10";
                    return {
                        number: row?.["$"]?.RowNumber,
                        seats,
                        isExit
                    };
                })
            )
        }
    })
    if (!Array.isArray(allRows)) return { rows: [] };
    return {rows : allRows}
}


function strToBuffer(str) {
    return new TextEncoder().encode(str);
}

function bufferToStr(buf) {
    return new TextDecoder().decode(buf);
}

function bufToBase64(buf) {
    return btoa(String.fromCharCode(...new Uint8Array(buf)));
}

function base64ToBuf(base64) {
    return Uint8Array.from(atob(base64), c => c.charCodeAt(0));
}


async function encryptData(plainText, password='huptechKey') {
    const enc = new TextEncoder();
    const keyMaterial = await crypto.subtle.importKey(
        "raw",
        enc.encode(password),
        "PBKDF2",
        false,
        ["deriveKey"]
    );

    const salt = crypto.getRandomValues(new Uint8Array(16));
    const iv = crypto.getRandomValues(new Uint8Array(12));

    const key = await crypto.subtle.deriveKey(
        {
            name: "PBKDF2",
            salt: salt,
            iterations: 100000,
            hash: "SHA-256",
        },
        keyMaterial,
        { name: "AES-GCM", length: 256 },
        false,
        ["encrypt", "decrypt"]
    );

    const cipherBuffer = await crypto.subtle.encrypt(
        { name: "AES-GCM", iv: iv },
        key,
        enc.encode(plainText)
    );

    // Combine salt, iv, and ciphertext → base64
    const combined = new Uint8Array([...salt, ...iv, ...new Uint8Array(cipherBuffer)]);
    return bufToBase64(combined);
}

async function decryptData(encryptedBase64, password='huptechKey') {
    const combined = base64ToBuf(encryptedBase64);
    const salt = combined.slice(0, 16);
    const iv = combined.slice(16, 28);
    const data = combined.slice(28);

    const enc = new TextEncoder();
    const keyMaterial = await crypto.subtle.importKey(
        "raw",
        enc.encode(password),
        "PBKDF2",
        false,
        ["deriveKey"]
    );

    const key = await crypto.subtle.deriveKey(
        {
            name: "PBKDF2",
            salt: salt,
            iterations: 100000,
            hash: "SHA-256",
        },
        keyMaterial,
        { name: "AES-GCM", length: 256 },
        false,
        ["decrypt"]
    );

    const decryptedBuffer = await crypto.subtle.decrypt(
        { name: "AES-GCM", iv: iv },
        key,
        data
    );

    return bufferToStr(decryptedBuffer);
}

const getRndInteger = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
};

const generateRandomString = (length = 15, char_type = 1) => {
    let characters = {
        1: '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ',
        2: '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ',
        3: '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ' + Date.now(),
    };
    let characters_str = characters[char_type],
        charactersLength = characters_str.length,
        randomString = '',
        i = 0;
    for (; i < length; i++) {
        randomString += characters_str[getRndInteger(0, charactersLength - 1)];
    }
    return randomString;
};

const formatDateFormat = (d) => {
    const date = new Date(d)
    if(isNaN(date.getTime())){
        return "Invalid Date"
    }
    const weekday = date.toLocaleString("en-US", { weekday: "short" });
    const day = date.toLocaleString("en-US", { day: "2-digit" });
    const month = date.toLocaleString("en-US", { month: "short" });
  const year = date.toLocaleString("en-US", { year: "numeric" });
    return `${weekday}, ${day} ${month} ${year}`;
}
const formatDate = (dateObj,addDay=true) => {
    if (!(dateObj instanceof Date) || isNaN(dateObj)) return "";

    const day = dateObj.toLocaleDateString("en-US", { weekday: "short" });
    const month = dateObj.toLocaleDateString("en-US", { month: "short" });
    const date = dateObj.getDate();

    return addDay ? `${day} , ${date} ${month}` : `${date} ${month}`;
}


const formatePriceFn = (currency = 'AED', amount, displayPrice = 0,isHeader=false) => {
    // Render the currency's SYMBOL, not its code: AED uses the dirham glyph via
    // the 'aedregular' font (hw-currency); USD/INR/EGP use their symbol ( ₹, E£)
    // in a normal font. A frozen booking view (getCurrencyOverride) wins.
    const effectiveCurrency = getCurrencyOverride() || currency || 'AED';
    const meta = getCurrencyMeta(effectiveCurrency);
    const isAED = !!meta.iconClass;
    const label = isAED ? (meta.glyph || 'AED') : (meta.symbol || effectiveCurrency);
    const gap = meta.space ? ' ' : '';
    return <span style={isHeader ? {color:"#3264FF"} : null}>
        <span style={isHeader ? {color:"#3264FF"} : null} className={isAED ? 'hw-currency ' : 'hw-currency-symbol '}>
            {label}{gap}
        </span>{amount}
    </span>;
}

const paymentCaptureCommonFn = async (paymentIntentId,userToken) => {
    const paymentCapture = await ApiCall('POST', `/payment-capture`, {paymentIntentId}, { authorization: userToken });
    return paymentCapture?.data?.data
}

const paymentCancelCommonFn = async (paymentIntentId,userToken) => {
    const paymentCancel = await ApiCall('POST', `/payment-cancel`, {paymentIntentId}, { authorization: userToken });
    return paymentCancel?.data?.data
}

// --------------------------------------------------------------------------
// Booked-flight price capture (used by ListFlightPage -> PassengerListPage)
//
// We only ever keep ONE entry in sessionStorage (the user's most recent Book
// click) instead of one per priceId. Each new capture overwrites the previous
// one, so 100+ searches in a day still leave at most two small keys behind.
// The captured entry carries its own (source, priceIdInUrl) so the booking
// page can verify the stored entry actually belongs to the URL it's reading
// — a stale entry from a previous click is treated as "no capture".
// --------------------------------------------------------------------------
const BOOKED_FLIGHT_PRICE_KEY = 'flightBookedPrice';
const BOOKED_FLIGHT_PRICE_ACK_KEY = 'flightBookedPriceAck';

const captureBookedFlightPriceFn = (source, priceIdInUrl, price, currency = 'AED') => {
    if (!source || priceIdInUrl === undefined || priceIdInUrl === null || priceIdInUrl === '') return;
    const numericPrice = Number(price);
    if (!Number.isFinite(numericPrice) || numericPrice <= 0) return;
    try {
        sessionStorage.setItem(BOOKED_FLIGHT_PRICE_KEY, JSON.stringify({
            source,
            priceIdInUrl: String(priceIdInUrl),
            price: numericPrice,
            currency: currency || 'AED',
            capturedAt: Date.now()
        }));
        // Fresh capture re-arms the popup — drop any previous acknowledgment.
        sessionStorage.removeItem(BOOKED_FLIGHT_PRICE_ACK_KEY);
    } catch (_) {
        // sessionStorage may be unavailable (e.g., privacy mode) — ignore.
    }
};

const getCapturedBookedFlightPriceFn = (source, priceIdInUrl) => {
    if (!source || priceIdInUrl === undefined || priceIdInUrl === null || priceIdInUrl === '') return null;
    try {
        const raw = sessionStorage.getItem(BOOKED_FLIGHT_PRICE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed || !Number.isFinite(Number(parsed?.price))) return null;
        // Only return the captured entry if it actually belongs to this booking URL.
        if (parsed?.source !== source || String(parsed?.priceIdInUrl) !== String(priceIdInUrl)) {
            return null;
        }
        return parsed;
    } catch (_) {
        return null;
    }
};

const acknowledgeBookedFlightPriceChangeFn = (source, priceIdInUrl) => {
    if (!source || priceIdInUrl === undefined || priceIdInUrl === null || priceIdInUrl === '') return;
    try {
        sessionStorage.setItem(BOOKED_FLIGHT_PRICE_ACK_KEY, JSON.stringify({
            source,
            priceIdInUrl: String(priceIdInUrl)
        }));
    } catch (_) {
        // ignore
    }
};

const isBookedFlightPriceChangeAcknowledgedFn = (source, priceIdInUrl) => {
    if (!source || priceIdInUrl === undefined || priceIdInUrl === null || priceIdInUrl === '') return false;
    try {
        const raw = sessionStorage.getItem(BOOKED_FLIGHT_PRICE_ACK_KEY);
        if (!raw) return false;
        const parsed = JSON.parse(raw);
        return parsed?.source === source && String(parsed?.priceIdInUrl) === String(priceIdInUrl);
    } catch (_) {
        return false;
    }
};


export {
    airlineImageFn,
    getQueryParams,
    convertMinutesFn,
    formatDateTime,
    getDateDifference,
    convertHourseFn,
    formatDayWiseDateFn,
    formatTimeWithDayAndTimeFn,
    differenceBetweenTwoDatesWithTime,
    passengerFormatString,
    formatPrice,
    formatPriceWithRate,
    phoneCodeImageFn,
    setCookie,
    getSharedCookieDomain,
    eraseHostCookie,
    getCookie,
    getBookingQueryParams,
    convertToMinutesAndSeconds,
    getUserTokenFn,
    getWithoutUserLogin,
    getUserToken,
    setUserToken,
    getYearOnDob,
    calcNights,
    getUserId,
    addServiceFees,
    getSessionStorage,
    setSessionStorage,
    getMinutesDifference,
    normalizeSeatsMap,
    encryptData,
    decryptData,
    formatDateMonthWise,
    generateRandomString,
    formatDateFormat,
    formatDate,
    paymentCaptureCommonFn,
    paymentCancelCommonFn,
    convertMinutesHeaderFn,
    countryCommonFn,
    formatePriceFn,
    captureBookedFlightPriceFn,
    getCapturedBookedFlightPriceFn,
    acknowledgeBookedFlightPriceChangeFn,
    isBookedFlightPriceChangeAcknowledgedFn
}
